import { Input, type InputProps } from "@repo/ui/components/Base/Input";
import { useField } from "formik";

interface FormikInputProps extends InputProps {
  name: string;
  type: string;
  placeholder?: string;
}

export const FormikInput = (props: FormikInputProps) => {
  const [field] = useField(props);
  return <Input {...field} {...props} />;
};
